
import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
//import messages from '../../redux/messages';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getFuncUsersData = (params, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_FUNC_FICHA,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(iType === 1 ? `/api/app/Formal_empleado/` : `/api/app/Funcional_empleado/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: params
    });
    dispatch({
      type: actions.GET_FUNC_FICHA,
      payload: {
        ficha: resp.data.data,
        fichaLength: resp.data.count //es un objeto completo, por eso se está manejando así. data es propio de axios lo que está
      }//despues de punto es referencia a una variable
      
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_FUNC_FICHA,
      payload: false
    });
  }
}

export const getGlobalFuncUserInfo = (params, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_FUNC_FICHA,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(iType === 1 ? `/api/app/Formal_busqueda_empleado/` : `/api/app/Funcional_busqueda_empleado/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: params
    });
    dispatch({
      type: actions.GET_FUNC_FICHA,
      payload: {
        ficha: resp.data.data,
        fichaLength: resp.data.count //es un objeto completo, por eso se está manejando así. data es propio de axios lo que está
      }//despues de punto es referencia a una variable
      
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_FUNC_FICHA,
      payload: false
    });
  }
}

//para llenar las tabs de detalle de empleado al hacer click sobre las cards de staffInventory
export const getFuncFichaEmpleado = (id, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_FUNC_FICHA_EMPLEADO,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(iType === 1 ? `/api/app/Formal_empleado/${id}` : `/api/app/Funcional_empleado/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    dispatch({
      type: actions.GET_FUNC_FICHA_EMPLEADO,
      payload: resp.data, //es un objeto completo, por eso se está manejando así. data es propio de axios lo que está
      //despues de punto es referencia a una variable
      
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_FUNC_FICHA_EMPLEADO,
      payload: false
    });
  }
}